<div [formGroup]="parentFormGroup" [ngClass]="componentClass" [class.red]="textColor == 'red'" [class.green]="textColor == 'green'" [class.black]="textColor =='black'" [class.no-label]="!label" [class.error]="isError" [class.disabled]="isDisabled" class="f-form_input">
    <!-- <input #input
           [type]="type"
           [formControlName]="controlName"
           [id]="controlName"
           [name]="controlName"
           [attr.placeholder]="placeholder"
           [attr.required]="isRequired ? '' : null"
           [attr.maxlength]="maxlength"
           [no-special-char]="noSpecialChar"
           [number-only]="numberOnly"
           (input)="onSearch($event)"/>
    <label class="label" [for]="controlName" [innerHTML]="label" *ngIf="label"></label> -->
    <div class="row justify-content-center">
        <input [type]="type"
               maxlength="1" 
               [attr.required] = "isRequired ? '' : null"
               [number-only]="numberOnly"
               [no-special-char]="noSpecialChar"
               (keyup)="onDigitInput($event)"/>  
        <input [type]="type" 
               maxlength="1" 
               [attr.required] = "isRequired ? '' : null"
               [number-only]="numberOnly"
               [no-special-char]="noSpecialChar"
               (keyup)="onDigitInput($event)"/>  
        <input [type]="type" 
               maxlength="1" 
               [attr.required] = "isRequired ? '' : null"
               [number-only]="numberOnly"
               [no-special-char]="noSpecialChar"
               (keyup)="onDigitInput($event)"/>  
        <input [type]="type" 
               maxlength="1" 
               [attr.required] = "isRequired ? '' : null"
               [number-only]="numberOnly"
               [no-special-char]="noSpecialChar"
               (keyup)="onDigitInput($event)"/> 
        <input [type]="type" 
               maxlength="1" 
               [attr.required] = "isRequired ? '' : null"
               [number-only]="numberOnly"
               [no-special-char]="noSpecialChar"
               (keyup)="onDigitInput($event)"/>  
        <input [type]="type" 
               maxlength="1" 
               [attr.required] = "isRequired ? '' : null"
               [number-only]="numberOnly"
               [no-special-char]="noSpecialChar"
               (keyup)="onDigitInput($event)"/>
    </div>
  </div>
  